import React from 'react';

import Data from 'data';
import { RawTooltip } from 'ui/tooltip';
import { formatHtml } from 'utils/format';

import { ItemIcon, ColorNumber } from './common';
import ItemTooltip, { CardTooltip, SocialActionTooltip, MusicTooltip, IslandTooltip, ItemSetTooltip } from './ItemTooltip';
import SkillTooltip, { EngravingTooltip, TripodTooltip, SkillGroupTooltip } from './SkillTooltip';

import './tooltip.scss';

export { ItemIcon, ColorNumber };

export { ItemTooltip, SkillTooltip, EngravingTooltip, TripodTooltip, SocialActionTooltip, MusicTooltip, SkillGroupTooltip, ItemSetTooltip };

export function WithItemTooltip({ item, ...props }) {
  if (typeof item !== 'object') item = {id: item, template: true};
  return <RawTooltip tooltip={<ItemTooltip item={item}/>} {...props}/>;
}

export function WithCardTooltip({ id, awake, ...props }) {
  return <RawTooltip tooltip={<CardTooltip id={id} awake={awake}/>} {...props}/>;
}

export function WithEngravingTooltip({ id, level, points, ...props }) {
  return <RawTooltip tooltip={<EngravingTooltip id={id} level={level} points={points}/>} {...props}/>;
}

export function WithSkillTooltip({ skill, pvp, ...props }) {
  if (typeof skill !== 'object') skill = {id: skill};
  return <RawTooltip tooltip={<SkillTooltip skill={skill} pvp={pvp}/>} {...props}/>;
}

export function WithTripodTooltip({ skill, tripod, level, level2, pvp, ...props }) {
  return <RawTooltip tooltip={<TripodTooltip skill={skill} tripod={tripod} level={level} level2={level2} pvp={pvp}/>} {...props}/>;
}

export function WithSocialActionTooltip({ id, ...props }) {
  return <RawTooltip tooltip={<SocialActionTooltip id={id}/>} {...props}/>;
}

export function WithMusicTooltip({ id, ...props }) {
  return <RawTooltip tooltip={<MusicTooltip id={id}/>} {...props}/>;
}

export function WithIslandTooltip({ id, ...props }) {
  return <RawTooltip tooltip={<IslandTooltip id={id}/>} {...props}/>;
}

export function WithItemSetTooltip({ id, ...props }) {
  return <RawTooltip tooltip={<ItemSetTooltip id={id}/>} {...props}/>;
}

export function MoneyTooltip({ id, amount }) {
  const money = Data.money[id];
  if (!money) return null;
  return (
    <div className="lap-SimpleTooltip">
      {formatHtml(money.desc, <ColorNumber value={amount || 0}/>, <ColorNumber value={money.max || 0}/>)}
    </div>
  );
}

export function WithMoneyTooltip({ id, amount, ...props }) {
  return <RawTooltip tooltip={<MoneyTooltip id={id} amount={amount}/>} {...props}/>;
}
